function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { PointerOnHover } from "../../styled/PointerOnHover";
import OperateImageModal from "./OperateImageModal";
import toggleOperation from "../toggleOperation/toggleOperation";

class OperateImage extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "toggleModal", () => {
      const _this = this;

      const promise = new Promise(function (resolve, reject) {
        _this.props.toggleModal();

        resolve(true);
      });
      promise.then(bool => {});
    });

    _defineProperty(this, "renderTrigger", () => {
      return /*#__PURE__*/React.createElement(PointerOnHover, {
        onClick: this.toggleModal
      }, this.props.children);
    });

    _defineProperty(this, "render", () => {
      const {
        handleImageSubmit,
        ...props
      } = this.props;
      return /*#__PURE__*/React.createElement(React.Fragment, null, this.renderTrigger(), /*#__PURE__*/React.createElement(OperateImageModal, _extends({
        modal: this.props.modal,
        toggle: this.toggleModal,
        handleImageSubmit: this.props.handleImageSubmit
      }, props), this.props.children));
    });
  }

}

export default toggleOperation(OperateImage);